import { Route, Redirect } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

export const AdminPrivateRoute = ({
  component: Comp,
  path,
  redirectedPath = "/login",
  ...rest
}) => {
  const { location } = useHistory();

  const { token, isLoggedIn, user } = useSelector((state) => {
    const { token, isLoggedIn, user } = state.userData;

    return { token, isLoggedIn, user };
  });

  return (
    <Route
      path={path}
      {...rest}
      render={(props) => {
        return token && isLoggedIn && user.isAdmin ? (
          <Comp {...props} />
        ) : (
          <Redirect
            to={{
              pathname: redirectedPath,
              state: {
                prevLocation: location.pathname,
                error: "Unauthorized Access!",
              },
            }}
          />
        );
      }}
    />
  );
};
